import { InputJson } from "nq-component";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import HolidaysFormPresenter from "./HolidaysFormPresenter";
import FormFactory from "../../../../components/FormFactory";
import MultipleSelectHierarchy from "../../../../components/common/MultipleSelectHierarchy";

class HolidaysFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      description: "",
      advanced: false,
      selectedType: "",
      holidayDate: "",
      objectID: "",
    };
    this.presenter = new HolidaysFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "holidays";
  }

  getStateRegion() {
    return this.state.selectedRegion;
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  fields = [
    "selectedregions",
    "selectedoffices",
    "selecteddivisions",
    "selectedsections",
    "selectedunits",
    "selectedplantilla",
  ];

  async handleHierarchyChange(object) {
    const filteredData = Object.keys(object)
      .filter((key) => this.fields.includes(key)) // Keep only matching keys
      .reduce((acc, key) => {
        const newKey = key.replace("selected", ""); // ✅ Remove "selected" prefix
        acc[newKey] = object[key]; // ✅ Store with modified key
        return acc;
      }, {});

    this.setState({ hierarchy: filteredData });
  }

  render() {
    const { object } = this.state;
    console.log("OBJECST: ", object);
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.save();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        // onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <FormFactory
                          className="col-lg-6"
                          schema={schema}
                          object={object}
                          onChange={this.onChange.bind(this)}
                        />

                        <div className="mt-3">
                          <MultipleSelectHierarchy
                            className="col-lg-6"
                            object={object}
                            required={true}
                            disabled={object?.selectAll}
                            handleObjectChange={this.handleHierarchyChange.bind(
                              this,
                            )}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                      // onClick={this.handleSubmit.bind(this)}
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(HolidaysFormPage);
